import { ReactNode } from 'react';
import clsx from 'clsx';
import { OutlinedTextFieldProps, TextField } from '@material-ui/core';
import { useSharedStyles } from '../../../common/sharedStyles';

export default (props: {
    autoFocus?: boolean;
    value?: string | number;
    className?: string;
    placeholder?: string;
    disabled?: boolean;
    maxLength?: string;
    endAdornment?: ReactNode;
} & OutlinedTextFieldProps) => {
    const { className, endAdornment, inputMode, inputProps, InputProps, maxLength, style, ...rest } = props;
    const sharedClasses = useSharedStyles();
    return <TextField
        fullWidth
        {...rest}
        variant="outlined"
        className={clsx(sharedClasses.input, className)}
        inputProps={{
            style: style,
            ...inputProps,
            maxLength,
            inputMode: inputMode
        }}
        InputProps={{
            ...InputProps,
            endAdornment
        }}
    />
}
